<div class="top-container" mat-dialog-title>
  <h2 class="title">
    {{ title | translate }}
    <span>{{ entityNameTitle }}</span>
  </h2>
  <div class="header-end">
    <ng-content select="[dialogHeaderActions]"></ng-content>
    @if (showCloseButton) {
      <mat-icon class="pointer-cursor" [mat-dialog-close]="false">close</mat-icon>
    }
  </div>
</div>
@if (subtitle) {
  <div class="top-container">
    <h4>{{ subtitle }}</h4>
  </div>
}
<div class="dialog-body">
  <ng-content></ng-content>
</div>

@if (shouldShowActions) {
  <div
    mat-dialog-actions
    class="buttons-container"
    [class.hide-actions-separator]="hideActionsSeparator"
  >
    @if (form && form.disabled) {
      <div>
        <app-ui-button
          color="primary"
          text="{{ 'edit' | translate }}"
          (click)="edit()"
          [privilege]="editPrivilege"
          [adminPrivilege]="adminPrivilege"
          [disabled]="editButtonDisabled"
        ></app-ui-button>
        <app-ui-button
          color="warn"
          buttonType="stroked"
          text="{{ 'delete' | translate }}"
          (click)="delete()"
          [privilege]="deletePrivilege"
          [adminPrivilege]="adminPrivilege"
        ></app-ui-button>
      </div>
    }
    @if (!form || form.enabled) {
      <div>
        @if (showDeleteButton) {
          <app-ui-button
            color="warn"
            buttonType="stroked"
            text="{{ 'delete' | translate }}"
            (click)="delete()"
            [privilege]="deletePrivilege"
            [adminPrivilege]="adminPrivilege"
          ></app-ui-button>
        }
        @if (showCancelButton) {
          <app-ui-button
            buttonType="secondary"
            text="{{ cancelButtonText | translate }}"
            [mat-dialog-close]="false"
          ></app-ui-button>
        }
        @if (showConfirmButton) {
          <app-ui-button
            id="confirm-button"
            [buttonType]="confirmButtonType"
            [color]="confirmButtonColor"
            [disabled]="confirmButtonDisabled"
            [loading]="confirmButtonLoading"
            text="{{ confirmButtonText | translate }}"
            [icon]="confirmButtonIcon"
            (click)="confirm()"
            [privilege]="createPrivilege"
            [adminPrivilege]="adminPrivilege"
          ></app-ui-button>
        }
      </div>
    }
  </div>
}
